import { render, staticRenderFns } from "./SubAgentTab.vue?vue&type=template&id=b4b7a3ee&scoped=true"
import script from "./SubAgentTab.vue?vue&type=script&lang=js"
export * from "./SubAgentTab.vue?vue&type=script&lang=js"
import style0 from "./SubAgentTab.vue?vue&type=style&index=0&id=b4b7a3ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b7a3ee",
  null
  
)

export default component.exports